<div class="file-download-container" fxLayout="row">
    <mat-icon class="txt-file-icon" svgIcon="txt-file"></mat-icon> 
    <span>Detalhes do {{type}}</span> 
    <div fxFlex fxLayout="row" fxLayoutAlign="end center" class="download-button-container">
        <button mat-stroked-button (click)="downloadFile()">Baixar arquivo <mat-icon>download</mat-icon></button>
    </div>
</div>